"use client";
import { ControlIcon as e } from "../controls/ControlIcon.js";
import { isPointerMenuEvent as t } from "./menu-motion.js";
import { NavigationLink as n } from "../controls/NavigationLink.js";
import { hoverHighlightClass as r, useHoverHighlight as i } from "../controls/useHoverHighlight.js";
import { ChevronRightIcon as a } from "../icons/ChevronRightIcon.js";
import { SearchMdIcon as o } from "../icons/SearchMdIcon.js";
import { Input as s } from "../input/Input.js";
import { Fragment as c, jsx as l, jsxs as u } from "react/jsx-runtime";
import d from "clsx";
import { Fragment as f, useId as p, useState as m } from "react";
import { Menu as h } from "@base-ui/react/menu";
import { useDirection as g } from "@base-ui/react/direction-provider";
//#region src/components/dropdown/MenuContent.tsx
var _ = ({ item: t }) => {
	let n = g();
	return /* @__PURE__ */ u(c, { children: [
		t.leadingIcon && /* @__PURE__ */ l(e, {
			size: 16,
			children: t.leadingIcon
		}),
		/* @__PURE__ */ u("span", {
			className: "pf-menu-text pf:flex pf:flex-col pf:flex-1 pf:min-w-0 pf:wrap-anywhere",
			children: [
				/* @__PURE__ */ l("span", { children: t.label }),
				t.description && /* @__PURE__ */ l("span", {
					className: "pf-menu-description pf:text-soft-pearl-800 pf:font-body pf:text-copy-12 pf:font-normal",
					children: t.description
				}),
				t.disabled && t.disabledReason && /* @__PURE__ */ l("span", {
					className: "pf-menu-description pf:text-soft-pearl-800 pf:font-body pf:text-copy-12 pf:font-normal",
					children: t.disabledReason
				})
			]
		}),
		t.trailingText && /* @__PURE__ */ l("span", {
			className: "pf-menu-meta pf:shrink pf:min-w-0 pf:max-w-[40%] pf:wrap-anywhere pf:text-soft-pearl-800 pf:font-body pf:text-[length:var(--pf-text-label-12)] pf:leading-[20px] pf:font-normal",
			children: t.trailingText
		}),
		t.trailingIcon && /* @__PURE__ */ l(e, {
			size: 16,
			children: t.trailingIcon
		}),
		t.type === "submenu" && /* @__PURE__ */ l("span", {
			className: d("pf-menu-chevron pf:flex pf:items-center pf:justify-center pf:shrink-0 pf:text-soft-pearl-800", n === "rtl" && "pf:rotate-180"),
			children: /* @__PURE__ */ l(a, {
				size: 16,
				tone: "inherit"
			})
		})
	] });
}, v = ({ item: e, portalContainer: r }) => {
	let i = p(), [a, o] = m(!1), s = [e.description, e.disabled ? e.disabledReason : void 0].filter(Boolean).join(". "), f = {
		className: d("pf:relative pf-menu-row pf:box-border pf:flex pf:items-center pf:gap-sm pf:min-h-[32px] pf:py-sm pf:ps-md pf:pe-lg", "pf:rounded-sm pf:outline-none pf:cursor-pointer", "pf:[&>.pf-control-icon]:shrink-0 pf:[&>.pf-control-icon]:text-soft-pearl-800", "pf:data-highlighted:bg-soft-pearl-200 pf:data-popup-open:bg-soft-pearl-200", "pf:data-destructive:not-data-disabled:text-red-700", "pf:data-destructive:not-data-disabled:[&>.pf-control-icon]:text-red-700", "pf:data-destructive:data-highlighted:bg-red-100 pf:data-disabled:text-soft-pearl-600", "pf:data-disabled:cursor-not-allowed pf:data-disabled:[&>.pf-control-icon]:text-soft-pearl-600"),
		disabled: e.disabled,
		label: e.label,
		"aria-label": e.label,
		"aria-describedby": s ? i : void 0
	};
	return /* @__PURE__ */ u(c, { children: [e.disabled ? /* @__PURE__ */ l("div", {
		className: f.className,
		role: "menuitem",
		"aria-disabled": "true",
		"aria-label": e.label,
		"aria-describedby": f["aria-describedby"],
		"data-disabled": "",
		children: /* @__PURE__ */ l(_, { item: e })
	}) : e.type === "submenu" ? /* @__PURE__ */ u(h.SubmenuRoot, {
		onOpenChange: (e, n) => {
			o(t(n.event));
		},
		children: [/* @__PURE__ */ l(h.SubmenuTrigger, {
			...f,
			children: /* @__PURE__ */ l(_, { item: e })
		}), /* @__PURE__ */ l(y, {
			animate: a,
			menu: e.menu,
			side: "inline-end",
			align: "start",
			portalContainer: r
		})]
	}) : e.type === "link" ? /* @__PURE__ */ l(h.Item, {
		...f,
		nativeButton: !1,
		render: /* @__PURE__ */ l(n, { linkConfig: e.linkConfig }),
		children: /* @__PURE__ */ l(_, { item: e })
	}) : /* @__PURE__ */ l(h.Item, {
		...f,
		"data-destructive": e.destructive || void 0,
		onClick: e.onClick,
		children: /* @__PURE__ */ l(_, { item: e })
	}), s && /* @__PURE__ */ l("span", {
		id: i,
		className: "pf-control-sr pf:sr-only",
		children: s
	})] });
}, y = ({ menu: e, animate: t = !1, finalFocus: n, side: a = "bottom", align: p = "start", sideOffset: g = 4, portalContainer: _ }) => {
	let y = i(), [b, x] = m(""), S = e.searchConfig?.value ?? b, C = e.loadingConfig?.isLoading ? [] : e.groups.map((t) => ({
		...t,
		items: !e.searchConfig || e.searchConfig.filter === "manual" || !S.trim() ? t.items : t.items.filter((e) => `${e.label} ${e.description ?? ""}`.toLocaleLowerCase().includes(S.trim().toLocaleLowerCase()))
	})).filter((e) => e.items.length);
	return /* @__PURE__ */ l(h.Portal, {
		container: _,
		children: /* @__PURE__ */ l(h.Positioner, {
			side: a,
			align: p,
			sideOffset: g,
			collisionPadding: 8,
			className: "pf-menu-positioner pf:z-50 pf:outline-none",
			children: /* @__PURE__ */ u(h.Popup, {
				...y.props,
				finalFocus: n,
				className: d(r, "pf-menu-popup pf:box-border pf:w-[240px] pf:max-w-(--available-width) pf:max-h-(--available-height)", "pf:overflow-y-auto pf:overscroll-contain pf:p-md pf:border-[0.5px] pf:border-solid", "pf:border-soft-pearl-300 pf:rounded-lg pf:bg-background pf:text-soft-pearl-1000", "pf:shadow-[0_1px_1px_#12121205,0_4px_10px_#12121214] pf:font-body pf:font-medium pf:text-[length:var(--pf-text-label-13)]", "pf:leading-[20px] pf:outline-none pf:origin-(--transform-origin)", "pf:data-animate:transition-[opacity,transform] pf:duration-(--pf-spring-snappy-duration) pf:ease-(--pf-spring-snappy-easing)", "pf:data-animate:data-starting-style:opacity-0 pf:data-animate:motion-safe:data-starting-style:[transform:translateY(-4px)_scale(0.96)]", "pf:data-animate:data-ending-style:opacity-0 pf:data-animate:motion-safe:data-ending-style:[transform:scale(0.98)] pf:data-ending-style:duration-[120ms] pf:data-ending-style:ease-(--pf-easing-out) pf:motion-reduce:transition-opacity pf:motion-reduce:duration-(--pf-duration-fast) pf:motion-reduce:ease-(--pf-easing-out)"),
				"data-animate": t || void 0,
				children: [
					y.highlight,
					e.searchConfig && /* @__PURE__ */ l("div", {
						className: "pf:pb-md",
						children: /* @__PURE__ */ l(s, {
							type: "search",
							className: "pf:[&_input::-webkit-search-cancel-button]:appearance-none pf:[&_button]:cursor-pointer",
							actionConfig: S ? { kind: "clear" } : void 0,
							leadingIcon: /* @__PURE__ */ l(o, {}),
							label: e.searchConfig.label,
							hideLabel: !0,
							value: S,
							onValueChange: (t) => {
								x(t), e.searchConfig?.onValueChange?.(t);
							},
							onKeyDown: (e) => {
								if (e.key === "ArrowDown" || e.key === "ArrowUp") {
									e.preventDefault(), e.stopPropagation();
									let t = e.currentTarget.closest("[role=\"menu\"]")?.querySelectorAll("[role=\"menuitem\"]:not([aria-disabled=\"true\"])");
									(e.key === "ArrowDown" ? t?.[0] : t?.[t.length - 1])?.focus();
								} else e.key !== "Escape" && e.key !== "Tab" && e.stopPropagation();
							}
						})
					}),
					e.loadingConfig?.isLoading && /* @__PURE__ */ l("div", {
						role: "status",
						className: "pf:px-md pf:py-sm pf:text-copy-12 pf:text-soft-pearl-800",
						children: e.loadingConfig.label ?? "Loading actions…"
					}),
					C.map((e, t) => /* @__PURE__ */ u(f, { children: [t > 0 && /* @__PURE__ */ l(h.Separator, { className: "pf-menu-separator pf:h-[0.5px] pf:bg-soft-pearl-300 pf:my-xs" }), /* @__PURE__ */ u(h.Group, { children: [e.label && /* @__PURE__ */ l(h.GroupLabel, {
						className: "pf-menu-group-label pf:py-sm pf:px-md pf:text-soft-pearl-800 pf:text-[length:var(--pf-text-label-12)]",
						children: e.label
					}), e.items.map((e) => /* @__PURE__ */ l(v, {
						item: e,
						portalContainer: _
					}, e.id))] })] }, e.id)),
					!e.loadingConfig?.isLoading && C.length === 0 && /* @__PURE__ */ l("div", {
						className: "pf-menu-empty pf:py-sm pf:px-md pf:text-soft-pearl-800 pf:text-[length:var(--pf-text-label-12)]",
						children: e.emptyContent ?? (S ? "No matching actions" : "No actions available")
					}),
					e.footerContent && /* @__PURE__ */ l("div", {
						className: "pf:border-0 pf:border-t-[0.5px] pf:border-solid pf:border-soft-pearl-300 pf:mt-xs pf:pt-md pf:px-md pf:text-copy-12 pf:text-soft-pearl-800",
						children: e.footerContent
					}),
					e.footerConfig && /* @__PURE__ */ u(c, { children: [/* @__PURE__ */ l(h.Separator, { className: "pf:h-[0.5px] pf:bg-soft-pearl-300 pf:my-xs" }), e.footerConfig.disabled ? /* @__PURE__ */ l("div", {
						role: "menuitem",
						"aria-disabled": "true",
						className: "pf:flex pf:min-h-[32px] pf:items-center pf:px-md pf:text-soft-pearl-600 pf:cursor-not-allowed",
						children: e.footerConfig.label
					}) : /* @__PURE__ */ l(h.Item, {
						onClick: e.footerConfig.onAction,
						disabled: e.footerConfig.disabled,
						className: "pf:box-border pf:flex pf:w-full pf:min-h-[32px] pf:items-center pf:px-md pf:rounded-sm pf:text-blue-700 pf:data-highlighted:bg-soft-pearl-200 pf:data-disabled:text-soft-pearl-600",
						children: e.footerConfig.label
					})] })
				]
			})
		})
	});
};
//#endregion
export { y as MenuContent };
